import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination } from 'swiper/modules';
import { useEffect, useState } from 'react';
import { getCars } from '../api';

export default function CarCarousel() {
    const [cars, setCars] = useState([]);

    useEffect(() => {
        getCars()
            .then((data) =>
                setCars(Array.isArray(data) ? data.filter((c) => c.active) : [])
            )
            .catch(() => setCars([]));
    }, []);

    if (!cars.length) return null; // 👈 Wenn keine Autos, gar nichts anzeigen

    return (
        <div className="max-w-4xl mx-auto my-8">
            <h2 className="text-2xl font-bold mb-4">Unsere Autos im Verkauf</h2>
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={20}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                className="relative z-0"
            >
                {cars.map((car) => (
                    <SwiperSlide key={car.id} className="relative z-0">
                        <div className="rounded-2xl shadow-md overflow-hidden bg-white relative z-0">
                            <img
                                src={`data:image/*;base64,${car.image}`}
                                alt={car.name}
                                className="w-full h-104 object-cover relative z-0"
                            />
                            <div className="p-4">
                                <h3 className="text-xl font-semibold">{car.name}</h3>
                                <p className="text-orange-600 font-bold">
                                    {car.price.toLocaleString("de-DE", {
                                        style: "currency",
                                        currency: "EUR",
                                    })}
                                </p>
                                {car.link && (
                                    <a
                                        href={car.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 underline"
                                    >
                                        Mehr
                                    </a>
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
